module.exports = __webpack_public_path__ + "static/pullquote2-4d6c1b57bfe4ce4daddbd2c22e7eea58.svg";